export default {
  props: ['type']
};